import React from 'react'
import { Row } from 'sidecar-components'
import { getInsuranceProduct, webStorage } from 'sidecar-utilities'
import { useFlags } from 'launchdarkly-react-client-sdk'

import { getRequestTypes } from 'utils/memberComm/getRequestTypes'

export const RequestTypeOptions = ({
  setRequestType,
  setPoptartHistory,
  testId,
}) => {
  const flags = useFlags()
  // get member's insurance product
  const insuranceProduct = getInsuranceProduct()

  // get product type from local storage as a fall back in case the member's
  // insurance product is not available
  const shMember = JSON.parse(webStorage.getItem('sh:member'))
  const localStorageInsuranceProduct = shMember?.policy?.insuranceProduct

  // Get the list of request types. Surgery intake (293) lives in the
  // complex care MFE, so it's excluded from the poptart.
  const requestTypes = getRequestTypes({
    insuranceProduct: insuranceProduct || localStorageInsuranceProduct,
    flags,
  }).filter(rt => rt.requestTypeId !== '293')

  return (
    <span data-testid={testId}>
      {requestTypes.map(requestType => (
        <Row
          testId={`info_requestTypeRow_${requestType.requestTypeId}`}
          key={requestType.requestTypeId}
          onClick={() => {
            setRequestType(requestType)
            setPoptartHistory(requestType.title)
          }}
        >
          {requestType.title}
        </Row>
      ))}
    </span>
  )
}
